import { BotVariables } from '@feedyou/schema'
import { STABLE_EMPTY_OBJECT } from '@feedyou/utils'

import { botFlowSelector } from './botFlowSelector'
import { RootState } from '../../../reducers'

export function botVariablesSelector(state: RootState): BotVariables {
  return botFlowSelector(state)?.variables || STABLE_EMPTY_OBJECT
}
